import * as actionTypes from "./actionTypes";
import {
  acceptRejectPerformanceSummaryAndResultsAPI,
  getPerformanceSummaryAndResultsAPI,
  previewSummaryAndResultsAPI,
  getSummaryAPI,
} from "@icarius-connection/api";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString, getErrorStringFromServerError } from "@icarius-localization/strings";
import { downloadBlob } from "@icarius-utils/download";
import { getFileExtension, getFileName } from "@icarius-utils/fileUpload";

const errorHandler = (e, dispatch) => {
  let errorString = "";
  switch (e.response?.data?.status) {
    case "INVALID_DATA":
    case "VALIDATION_ERROR":
      errorString = getLocalizedString("validationError");
      break;
    default:
      errorString = getErrorStringFromServerError(e);
      break;
  }
  dispatch(openSnackbarAction({ msg: errorString, severity: "error" }));
}


export const getPerformanceSummaryAndResultsAction = () => async (dispatch) => {
  dispatch({ type: actionTypes.GET });
  try {
    let response = await getPerformanceSummaryAndResultsAPI();

    let data = response.data && response.data.data;
    let isAcceptRejectEnabled = response.data && response.data.isAcceptRejectEnabled;
    let isSocietySignActive = response.data && response.data.isSocietySignActive;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_FULFILLED,
      payload: {
        data,
        isAcceptRejectEnabled,
        isSocietySignActive,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const getSummaryAction = (process, employeeCode) => async (dispatch) => {
  dispatch({ type: actionTypes.GET_SUMMARY });
  try {
    let params = new URLSearchParams();
    params.set("processCode", process);
    params.set("evaluatedCode", employeeCode);

    let response = await getSummaryAPI(`?${params.toString()}`);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.GET_SUMMARY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.GET_SUMMARY_FULFILLED,
      payload: {
        data,
      },
    });
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.GET_SUMMARY_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};


export const acceptRejectPerformanceSummaryAndResultsAction = (dataToSend) => async (dispatch) => {
  dispatch({ type: actionTypes.ACCEPT_REJECT });
  try {
    let response = await acceptRejectPerformanceSummaryAndResultsAPI(dataToSend);

    let data = response.data && response.data.data;
    let status = response.data && response.data.status;

    if (status !== "OK") {
      dispatch({ type: actionTypes.ACCEPT_REJECT_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({
      type: actionTypes.ACCEPT_REJECT_FULFILLED,
      payload: {
        data,
      },
    });

    dispatch(openSnackbarAction({ msg: dataToSend.approves === 'N' ? getLocalizedString("performanceSummaryResultAcceptRejectRefused") : getLocalizedString("performanceSummaryResultAcceptRejectAccepted"), severity: "success" }));
    return response;
  } catch (e) {
    dispatch({ type: actionTypes.ACCEPT_REJECT_REJECTED, payload: e });
    errorHandler(e, dispatch);
  }
};

export const previewDocumentsAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.PREVIEW_SUMMARY });
  try {
    let response = await previewSummaryAndResultsAPI(data);

    if (response.status !== 200) {
      dispatch({ type: actionTypes.PREVIEW_SUMMARY_REJECTED });
      dispatch(openSnackbarAction({ msg: getLocalizedString("defaultException"), severity: "error" }));
      return;
    }

    dispatch({ type: actionTypes.PREVIEW_SUMMARY_FULFILLED });
    let title = response.headers["x-content-namefile"];
    downloadBlob(response.data, getFileExtension(title), getFileName(title));

    return response;
  } catch (e) {
    dispatch(openSnackbarAction({ msg: getErrorStringFromServerError(e), severity: "error" }));
    dispatch({ type: actionTypes.PREVIEW_SUMMARY_REJECTED, payload: e });
    return e.response;
  }
};